import {
    Orbit,
    Navigation,
    MapPin,
    Globe,
    Code2,
    Smartphone,
    BarChart3,
    Palette,
} from "lucide-react";
import { motion } from "framer-motion";
import { SectionHead } from "./Reveal";

const FEATURES = [
    { icon: Orbit, title: "Immersive 360° View", desc: "Every corner, every angle, every detail — captured in stunning clarity your customers can feel." },
    { icon: Navigation, title: "Interactive Navigation", desc: "Glide from the lobby to the rooftop with a single tap, exactly like walking through in person." },
    { icon: MapPin, title: "Interactive Hotspots", desc: "Turn walls into storytellers — pin videos, menus, prices and booking links right inside your space." },
    { icon: Globe, title: "Google Integration", desc: "Shine on Google Search and Maps with a richer listing that makes nearby customers stop and look." },
    { icon: Code2, title: "Website Integration", desc: "One simple embed and your website becomes a walk-in experience, not a brochure." },
    { icon: Smartphone, title: "Mobile Friendly", desc: "Butter-smooth on every phone, tablet and desktop — because that's where your customers are." },
    { icon: BarChart3, title: "Tour Analytics", desc: "See how many people explored your space, which rooms they loved and when they visited." },
    { icon: Palette, title: "Custom Branding", desc: "Your logo, your colours, your vibe — the tour feels like your brand, not a template." },
];

export default function Features() {
    return (
        <section id="features" className="relative py-20 lg:py-32" data-testid="features-section">
            <div className="absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-[#00C6FF]/8 blur-[120px]" />
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHead
                    chapter="04"
                    eyebrow="Capabilities"
                    title="POWERFUL 360° FEATURES"
                    sub="Everything your customers need to explore your space."
                />
                <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {FEATURES.map((f, i) => (
                        <motion.div
                            key={f.title}
                            data-testid={`feature-card-${i}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: (i % 4) * 0.09, ease: [0.22, 1, 0.36, 1] }}
                            whileHover={{ y: -8 }}
                            className="glass-card group relative overflow-hidden rounded-2xl p-7"
                        >
                            <span className="font-mono-accent absolute right-5 top-5 text-xs text-[#00C6FF]/40">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#00C6FF]/40 bg-[#050B14]/60 text-[#00C6FF] transition-transform duration-500 group-hover:rotate-[360deg]">
                                <f.icon size={22} />
                            </span>
                            <h3 className="mt-5 text-lg font-semibold text-white">{f.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-slate-400">{f.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
